import React, { Suspense, lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const EditLogonId = lazy(
  () => import('@pages/dashboard/AccessAndSecurity/components/EditLogonId'),
);
const EditPassword = lazy(
  () => import('@pages/dashboard/AccessAndSecurity/components/EditPassword'),
);

export const AccessAndSecurityRoutes: RouteObject = {
  handle: {
    label: 'Access & Security',
    skipBreadCrumb: true,
  },
  children: [
    {
      path: '/dashboard/edit-logon-id',
      handle: {
        label: 'Edit Logon ID',
        disabled: true,
      },
      element: (
        <Suspense>
          <EditLogonId />
        </Suspense>
      ),
    },
    {
      path: '/dashboard/edit-password',
      handle: {
        label: 'Edit Password',
        disabled: true,
      },
      element: (
        <Suspense>
          <EditPassword />
        </Suspense>
      ),
    },
  ],
};
